import { render, staticRenderFns } from "./VDatePicker.vue?vue&type=template&id=5e5e54f9&scoped=true&"
import script from "./VDatePicker.vue?vue&type=script&lang=ts&"
export * from "./VDatePicker.vue?vue&type=script&lang=ts&"
import style0 from "./VDatePicker.vue?vue&type=style&index=0&id=5e5e54f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5e54f9",
  null
  
)

export default component.exports